import MeansPackage from 'views/MeansPackage/index.vue';
import InvestmentPage from 'views/InvestmentPage/index.vue';
import InvestmentPagePc from 'views/InvestmentPagePc/index.vue';
import Search360PagePC from 'views/Search360Page/index.vue';
import Displaynumber from 'views/Displaynumber/index.vue';

export default [
  {
    path: '/',
    redirect: '/meansPackage',
  },
  {
    path: '/meansPackage',
    name: 'meansPackage',
    component: MeansPackage,
    meta: {
      title: '资料包',
    },
  },
  {
    path: '/investmentPage',
    name: 'InvestmentPage',
    component: InvestmentPage,
    meta: {
      title: '充电宝招商页',
    },
  },
  {
    path: '/investmentPagePc',
    name: 'InvestmentPagePc',
    component: InvestmentPagePc,
    meta: {
      title: '充电宝招商页',
    },
  },
  {
    path: '/LandingPagePC',
    name: 'Search360PagePC',
    component: Search360PagePC,
    meta: {
      title: '美团充电宝',
    },
  },
  {
    path: '/displaynumber',
    name: 'Displaynumber',
    component: Displaynumber,
    meta: {
      title: '美团充电宝官方外呼电话',
    },
  },
];
